<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li>
          <router-link to="/admin">Dashboard</router-link>
        </li>
        <li class="active">Report All Partner Point Balance</li>
      </ol>
      <div class="row">
        <div class="col-md-12">
           <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
          <div v-if="ErrorMessage" class="alert-danger alert visibility" role="alert">
            {{ ErrorMessage }}
          </div>
        </div>
        <div class="col-md-3">
          <div id="search-box">
            <div class="form-group">
              <label for="searchbox">Search</label>
              <input
                type="text"
                class="search-query form-control"
                placeholder="Search"
                v-model="searchText"
                name="searchbox"
              />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="To">Partner Type</label>
          <v-select v-model="PartnerTypeSelected" :options="PartnerOptions" :reduce="partnerDetails => partnerDetails.code" label="name" />
          </div>
        </div>
        <div class="col-md-6">
              <div class="form-group">
                <label>State Select</label>
                <selectState 
                 :selectedOptionArray ="StateAlready"
                :remoteControl="'kspgAPI/Part/PartnerStates'" @selectedData="StateSelect"></selectState>              
            </div>
        </div>
        <div class="col-md-3 ">
          <div class="form-group">
            <button
              type="button"
              v-on:click="getAllUsers(1)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Filter
            </button>
          </div>
        </div>
       
       <div class="col-md-3">
          <div class="form-group">
            <button
              type="button"
              v-on:click="exportReport(0)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Export To CSV
            </button>
          </div>
        </div>
        
      </div>
      <div class="row">

        <div class="col-md-12">
          <div class="panel panel-default visibility" id="panel-inline">
            <div class="panel-heading">
              <div class="panel-ctrls"></div>
            </div>
            <div class="panel-body no-padding visibility">
              <table
                class="table table-striped table-bordered"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Partner ID</th>
                    <th>Partner Name</th>
                    <th>Partner Type</th>
                    <th>Address</th>
                    <th>PIN Code</th>
                    <th>State</th>
                    <th>City</th>
                    <th>Current Total Points Accumulated</th>
                    <th>Point Balance</th>
                    <th>Current Total Points Redeemed</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <tr class="odd gradeX"> -->
                  <tr
                    v-for="(item, index) in users_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td>
                      {{ item.UserCode }}
                    </td>
                    <td>{{ item.first_name | removeNull}} {{item.last_name | removeNull}}</td>
                    <td>{{ item.PartnerType }}</td>
                    <td>{{ item.AddressLine1 | removeNull }} {{ item.AddressLine2 | removeNull }}</td>
                    <td>{{ item.ZIP | removeNull}}</td>
                    <td>{{ item.State | removeNull }}</td>
                    <td>{{ item.selectedCity | removeNull}}</td>
                    <td>{{ item.TotalPoints | removeNull }}</td>
                    <td>{{ item.TotalPoints - item.RedeemptionPoints  | setnullZero }}</td>
                    <td>{{ item.RedeemptionPoints | setnullZero }}</td>
                  </tr>
                </tbody>
              </table>
              <!--end table-->
            </div>
            <div class="panel-footer">
              <paginate
                :page-count="TotalPage"
                :click-handler="getAllUsers"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  

  </div>
</template>
<script>
import Paginate from 'vuejs-paginate';

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import commonServices from '../../services/common-services';
export default {
  name: 'brand-admin',
  data() {
    return {
      KYCData:'',
      uploadFile: '',
      users_data: [],
      searchText: '',
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage: 1,
      message:'',
      SuccessMessage:'',
      ErrorMessage:'',
      PartnerOptions: [
      {code: 'Retailer','name':'Retailer'},
      {code: 'Reborer','name':'Reborer'},
      {code: 'Grinder','name':'Grinder'},
      {code: 'ReborerPlusGrinder','name':'Reborer Plus Grinder'},
      {code: 'Mechanics','name':'Mechanics'},
      ],
      PartnerTypeSelected:'',
      StateAlready:{},
      stateSelected:'',
    };
  },
  components: {
    selectState:() => import( '../components/Select2SearchWithTokenPrefetch.vue'),
    'Paginate':Paginate,
    vSelect:vSelect,
  },

  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  methods: {
   
    getRequestParams(searchText, page, pageSize) {
      let params = {};
      if(this.PartnerTypeSelected){
         params['PartnerTypeSelected'] = this.PartnerTypeSelected;
      }
      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }
     if(this.stateSelected){
        params['State'] = this.stateSelected;
      } 
      return params;
    },
     exportReport(pageNum){
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      
      commonServices
        .get('kspgAPI/Partners/ListReportExport', params)
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'file.csv');
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((e) => {
           if(e.response.data.error == "Invalid API key "){
             loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
      setTimeout(() => {loader.hide()}, 1000)
    },
    getAllUsers(pageNum) {
      let loader = this.$loading.show();
      this.skyloStart();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/Partners/Reportlist', params)
        .then((response) => {
          const {
            users_data,
            totalItems,
            currentPage,
            TotalPage,
          } = response.data;
          this.users_data = users_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
        })
        .catch((e) => {
           if(e.response.data.error == "Invalid API key "){
             loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
      this.skyloEnd();
      setTimeout(() => {loader.hide()}, 1000)
    },
   StateSelect(val){
      this.stateSelected = val;
    }
  },
  computed() {},
  created() {
    // this.firstCallData;
  },
  mounted() {
    console.warn(this.$store.state.common.username);
    console.warn(this.$store.state.common.globalMenues);
    this.getAllUsers(1);
  },
   filters: {
    removeNull(data) {
      if (!data) {
        return '';
      }
      return data;
    },
    setnullZero(data) {
      if (!data) {
        return '0';
      }
      return data;
    },
  },
};
</script>
<style scoped>
.visibility {
  visibility: visible !important;
}
.search-button {
  background-color: #555555;
  color: #ffffff;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.close  {
  color: #000 !important;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.align-left {
  text-align: left !important;
  padding-left:10px;
}
</style>
